import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default ({
  state: {
    loadedMembers: []
  },
  mutations: {
    createMember (state, payload) {
      state.loadedMembers.push(payload)
    },
    updateMember (state, payload) {
      const member = state.loadedMembers.find(member => {
        return member.id === payload.id
      })
      if (payload.memberid) {
        member.memberid = payload.memberid
      }
      if (payload.name) {
        member.name = payload.name
      }
      if (payload.gender) {
        member.gender = payload.gender
      }
      if (payload.role) {
        member.role = payload.role
      }
      if (payload.location) {
        member.location = payload.location
      }
      if (payload.email) {
        member.email = payload.email
      }
      if (payload.contact) {
        member.contact = payload.contact
      }
    },
    setLoadedMembers (state, payload) {
      state.loadedMembers = payload
    },
    deleteMember (state, payload) {
      for (var i = 0; i < state.loadedMembers.length; i++) {
        if (state.loadedMembers[i].id === payload) {
          state.loadedMembers.splice(i, 1)
        }
      }
    }
  },
  actions: {
    loadMembers ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('members').once('value')
        .then((data) => {
          const members = []
          const obj = data.val()
          for (const key in obj) {
            members.push({
              id: key,
              memberid: obj[key].memberid,
              name: obj[key].name,
              gender: obj[key].gender,
              role: obj[key].role,
              location: obj[key].location,
              email: obj[key].email,
              contact: obj[key].contact,
              creatorId: obj[key].creatorId
            })
          }
          commit('setLoading', false)
          commit('setLoadedMembers', members)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    createMember ({ commit, getters }, payload) {
      const member = {
        memberid: payload.memberid,
        name: payload.name,
        gender: payload.gender,
        role: payload.role,
        email: payload.email,
        contact: payload.contact,
        creatorId: getters.user.id,
        location: payload.location
      }
      firebase.database().ref('members').push(member)
        .then((data) => {
          const key = data.key
          commit('createMember', {
            ...member,
            id: key
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateMember ({ commit }, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.memberid) {
        updateObj.memberid = payload.memberid
      }
      if (payload.name) {
        updateObj.name = payload.name
      }
      if (payload.gender) {
        updateObj.gender = payload.gender
      }
      if (payload.role) {
        updateObj.role = payload.role
      }
      if (payload.location) {
        updateObj.location = payload.location
      }
      if (payload.email) {
        updateObj.email = payload.email
      }
      firebase.database().ref('members').child(payload.id).update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('updateMember', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    deleteMember ({ commit }, payload) {
      firebase.database().ref('members').child(payload).remove()
      commit('deleteMember', payload)
    }
  },
  getters: {
    loadedMembers (state) {
      return state.loadedMembers.sort((memberA, memberB) => {
        return memberA.memberid > memberB.memberid
      })
    },
    loadedMember (state) {
      return (memberId) => {
        return state.loadedMembers.find((member) => {
          return member.id === memberId
        })
      }
    },
    featuredMembers (state, getters) {
      return getters.loadedMembers.slice(0, 5)
    }
  }
})
